"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Button_1 = __importDefault(require("@mui/material/Button"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Container_1 = __importDefault(require("@mui/material/Container"));
var styles_1 = require("@mui/material/styles");
var theme_1 = __importDefault(require("../public/themes/theme"));
var AxiosClient_1 = require("../utils/AxiosClient");
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var js_cookie_1 = __importDefault(require("js-cookie"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
// notifications import
var Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var theme = theme_1.default;
function SignUp() {
    // sign up form states
    var _a = (0, react_1.useState)({
        firstName: "",
        lastName: "",
        email: "",
        phone_number: "",
        password: "",
    }), formData = _a[0], setFormData = _a[1];
    var handleInput = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[name] = value, _a)));
    };
    var navigate = (0, react_router_dom_1.useNavigate)();
    // notifications states
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    var _c = (0, react_1.useState)(""), message = _c[0], setMessage = _c[1];
    var _d = (0, react_1.useState)("warning"), severityType = _d[0], setSeverityType = _d[1];
    var _e = React.useState(false), loading = _e[0], setLoading = _e[1];
    // <MyAlert severity="error" message="This is an error message!" />
    var handleClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        setLoading(true);
        console.log(formData);
        AxiosClient_1.AxiosClient.post("/signup", formData)
            .then(function (response) {
            // Handle successful response
            var notificationMessage = "Welcome ".concat(formData.firstName, " ").concat(formData.lastName, " You successfully registered");
            setSeverityType("success");
            setOpen(true);
            setMessage(notificationMessage);
            console.log(response);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var token = response.data.token;
            axios_1.default.defaults.headers.common["Authorization"] = "Bearer ".concat(token);
            // document.cookie = `token=${token}`;
            js_cookie_1.default.set("token", token);
            navigate("/");
        })
            .catch(function (error) {
            setLoading(false);
            console.log(error);
            if (error.response.data.error) {
                var notificationMessage = error.response.data
                    .error;
                // that falls out of the range of 2xx
                setSeverityType("warning");
                setOpen(true);
                setMessage(notificationMessage);
            }
            else if (error.response.data.message) {
                var notificationMessage = error.response.data
                    .message;
                // user exist
                setSeverityType("warning");
                setOpen(true);
                setMessage(notificationMessage);
            }
            else {
                var notificationMessage = "Network Error, Try Again";
                setSeverityType("warning");
                setOpen(true);
                setMessage(notificationMessage);
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar_1.default, { iconNumber: 2 }),
        React.createElement(styles_1.ThemeProvider, { theme: theme },
            React.createElement(Container_1.default, { component: "main", maxWidth: "xs" },
                React.createElement(CssBaseline_1.default, null),
                React.createElement(Box_1.default, { sx: {
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    } },
                    React.createElement(Typography_1.default, { variant: "h6" }, "!shop"),
                    React.createElement(Typography_1.default, { component: "h1", variant: "h4", color: "primary" }, "Sign up"),
                    React.createElement(Box_1.default, { component: "form", noValidate: true, onSubmit: handleSubmit, sx: { mt: 3 } },
                        React.createElement(Grid_1.default, { container: true, spacing: 2 },
                            React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6 },
                                React.createElement(TextField_1.default, { value: formData.firstName, onChange: handleInput, autoComplete: "given-name", name: "firstName", required: true, fullWidth: true, id: "firstName", label: "First Name" })),
                            React.createElement(Grid_1.default, { item: true, xs: 12, sm: 6 },
                                React.createElement(TextField_1.default, { value: formData.lastName, onChange: handleInput, required: true, fullWidth: true, id: "lastName", label: "Last Name", name: "lastName", autoComplete: "family-name" })),
                            React.createElement(Grid_1.default, { item: true, xs: 12 },
                                React.createElement(TextField_1.default, { value: formData.email, onChange: handleInput, required: true, fullWidth: true, id: "email", label: "Email Address", name: "email", autoComplete: "email" })),
                            React.createElement(Grid_1.default, { item: true, xs: 12 },
                                React.createElement(TextField_1.default, { value: formData.phone_number, onChange: handleInput, required: true, fullWidth: true, id: "phone", label: "Phone Number (eg: +250780....)", name: "phone_number", autoComplete: "phone" })),
                            React.createElement(Grid_1.default, { item: true, xs: 12 },
                                React.createElement(TextField_1.default, { value: formData.password, onChange: handleInput, required: true, fullWidth: true, name: "password", label: "Password", type: "password", id: "password", autoComplete: "new-password" }))),
                        React.createElement(Button_1.default, { type: "submit", fullWidth: true, variant: "contained", disabled: loading, sx: { mt: 3, mb: 2 } }, "Sign Up"),
                        React.createElement(Grid_1.default, { container: true, justifyContent: "flex-end" },
                            React.createElement(Grid_1.default, { item: true },
                                React.createElement(Link_1.default, { href: "/login", variant: "body2" }, "Already have an account? Sign in"))))))),
        React.createElement(Snackbar_1.default, { open: open, autoHideDuration: 6000, onClose: handleClose },
            React.createElement(Alert_1.default, { onClose: handleClose, severity: severityType, sx: { width: "100%" } }, message))));
}
exports.default = SignUp;
